import React from 'react'
import styled from 'styled-components'

import { Select } from 'components/common'

const Wrapper = styled.div`
  width: 286px;
  margin: 0px 10px 20px 0px;
  height: 88px;
  border: 2px solid #DCE6F2;
  border-radius: 8px;
  padding: 16px;
  display: flex;
  align-items: center;
  &.selected {
    border: 2px solid #3F76E6;
  }
  img {
    width: 50px;
    height: 50px;
    border: 1px solid #DCE6F2;
    display:inline-block;
    margin-right:12px;
    border-radius: 6px;
  }
  p {
    margin: 0;
    margin-right: auto;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    overflow-wrap: break-word;
  }
  input {
    width:54px;
  }
  .select-wrapper {
    &>div {
      width: 82px;
      min-width: 54px !important;
      .item-selector__control {
        border: 1px solid #DCE6F2;
        border-radius: 5px;
        .item-selector__indicators .item-selector__indicator-separator {
          display: none;
        }
        .item-selector__indicator.item-selector__dropdown-indicator {
          padding-left:0;
        }
      }
    }
  }
`;

const makeOptions = (total) => {
  return Array(parseInt(total, 10) + 1)
    .fill()
    .map((v,i)=>i)
    .map(val => ({ value: `${val}`, label: `${val}` }))
}

const ItemInput = ({ item, value, onChange, selected = false }) => {
  return (
    <Wrapper className={`item-input ${selected ? 'selected': ''}`}>
      <img src={item?.imageUrl} alt="item"/>
      <p>{item?.name}</p>
      <div className="select-wrapper">
        <Select
          value={value}
          classNamePrefix="item-selector"
          instanceId="item-selector"
          options={makeOptions(1)}
          placeholder={"0"}
          onChange={onChange}
        />
      </div>
    </Wrapper>
  )
}

export default ItemInput
